import { isValid } from '@fnando/cpf';

import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';

import { createAlphanumericFormatter } from '../generators';

export const PERSON_ID = 'person-id';

const PersonIdFormatter = createAlphanumericFormatter({
  name: PERSON_ID,
  mask: '000.000.000-00',
  validate: isValid,
  invalidMessage: 'tws.formatter.personId.invalid',
});

export default registerFormatter(PERSON_ID, PersonIdFormatter);
